import apiClient from './apiClient';

export const datasetApi = {
  getDatasets: async () => {
    const response = await apiClient.get('/datasets');

    // The backend returns: { id, name, type, status, created_at }
    // type is 'bigquery' or 'upload'
    return response.data.map(d => ({
      id: d.id,
      name: d.name,
      type: d.type,
      size: 'N/A',
      date: 'Recent',
      status: d.status,
      created_at: d.created_at
    }));
  },

  deleteDataset: async (id) => {
    const response = await apiClient.delete(`/datasets/metadata/${id}`);
    return response.data;
  },

  uploadDataset: async (file, name) => {
    const formData = new FormData();
    formData.append('file', file);
    if (name) formData.append('name', name);

    const response = await apiClient.post('/datasets/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  importBigQueryTables: async (data) => {
    const response = await apiClient.post('/datasets/bigquery', data);
    return response.data;
  },

  getDatasetMetadata: async (id) => {
    const response = await apiClient.get(`/datasets/metadata/${id}`);
    return response.data;
  },

  updateDatasetMetadata: async (id, data) => {
    const response = await apiClient.patch(`/datasets/metadata/${id}`, data);
    return response.data;
  },

  rebuildMetadata: async (table_id) => {
    const response = await apiClient.post(`/datasets/${table_id}/rebuild`);
    return response.data;
  },

  getDistinctValues: async (tableId, column) => {
    const response = await apiClient.get(`/datasets/${tableId}/distinct`, {
      params: { column }
    });
    return response.data.values;
  },

  getColumnRange: async (tableId, column) => {
    const response = await apiClient.get(`/datasets/${tableId}/range`, {
      params: { column }
    });
    return response.data;
  },

  getSamples: async () => {
    const response = await apiClient.get('/datasets/samples');
    return response.data;
  },

  addSample: async (tableId) => {
    const response = await apiClient.post(`/datasets/samples/${tableId}`);
    return response.data;
  }
};
